import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "./AdminLayout";
import ProtectedRoute from "./ProtectedRoute";

import Dashboard from "./Dashboard";
import CreateBlog from "./Create/CreateBlog";
import CreateCareer from "./Create/CreateCareer";
import JobApplicants from "./Applicants/ApplicantList";
import BlogVisitReport from "./BlogVisits/BlogVisitReport";

const AdminApp = () => {
  return (
    <ProtectedRoute>
      <Routes>

        {/* Parent layout */}
        <Route path="/" element={<AdminLayout />}>

          {/* ✅ Default route → dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          {/* ✅ CHILD ROUTES (RELATIVE PATHS ONLY) */}
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="create-blog" element={<CreateBlog />} />

          <Route path="create-career" element={<CreateCareer />} />

          <Route path="job-applicants" element={<JobApplicants />} />

          <Route path="blog-visit" element={<BlogVisitReport />} />

          {/* ✅ fallback route */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />

        </Route>

      </Routes>
    </ProtectedRoute>
  );
};

export default AdminApp;